"use client";
import { jsx } from "react/jsx-runtime";
import "react";
import { PortalContainerContext } from "./portalContainerContext.js";
function PortalContainerProvider({ children, container }) {
    return /*#__PURE__*/ jsx(PortalContainerContext.Provider, {
        value: container ?? null,
        children: children
    });
}
export { PortalContainerProvider };
